import { z } from 'zod';

import { AddressFieldsFormFields } from 'src/constants/address';
import {
  feinZodValidationSchema,
  phoneNumberZodValidationSchema,
  taxYearEndDateSimpleZodValidationSchema,
  zipCodeZodValidationSchema,
} from 'src/constants/validation';
import { selectFieldOptionValidationSchema } from 'src/constants/validation/form';

import { PeoCompanyInformationFormFields, PeoCompanyInformationFormValues } from '../types';

export const peoCompanyInformationFormValidationSchema = z.object({
  [PeoCompanyInformationFormFields.displayName]: z.string('Required company display name'),
  [PeoCompanyInformationFormFields.fein]: feinZodValidationSchema,
  [PeoCompanyInformationFormFields.industry]: selectFieldOptionValidationSchema.nullish(),
  [PeoCompanyInformationFormFields.taxYearEndDate]: taxYearEndDateSimpleZodValidationSchema,
  [PeoCompanyInformationFormFields.numberOfEmployees]: z.int('Invalid value').positive().nullish(),
  [PeoCompanyInformationFormFields.corporateStructure]: z.string().nullish(),
  [PeoCompanyInformationFormFields.contactPhoneNumber]: phoneNumberZodValidationSchema,
  [PeoCompanyInformationFormFields.contactEmail]: z.email('Required contact email'),
  [PeoCompanyInformationFormFields.defaultDisclaimer]: z.string().nullish(),
  [PeoCompanyInformationFormFields.headquarters]: z.object({
    [AddressFieldsFormFields.street]: z.string('Required street'),
    [AddressFieldsFormFields.city]: z.string('Required city'),
    [AddressFieldsFormFields.county]: z.string().nullable(),
    [AddressFieldsFormFields.state]: z.string('Required state'),
    [AddressFieldsFormFields.zipCode]: zipCodeZodValidationSchema,
  }),
}) satisfies z.ZodType<PeoCompanyInformationFormValues>;
